export const getters = {
  getAuditLogs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getAppliedAuditlogsFilters: _state => {
    return _state.appliedFilters;
  },
  getSearchQuery: _state => {
    return _state.searchQuery;
  },
  getCurrentFilterQuery: _state => {
    return _state.currentFilterQuery;
  },
  getCurrentExportType: _state => {
    return _state.exportType;
  },
};
